import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import imagesLoaded from 'imagesloaded'

gsap.registerPlugin(SplitText)

const bar = document.querySelector('.loading__bar')
let c = 0
let barInterval = setInterval(() => {
  bar.style.width = c + '%'
  c++
  if (c === 101) {
    clearInterval(barInterval)
    gsap.to('.loading', {
      position: 'fixed'
      // overflow: 'hidden'
    })
    gsap.to('.loading__bar', {
      duration: 1,
      opacity: 0
    })
    gsap.to('.loading__component', {
      duration: 1,
      delay: 0.5,
      height: '400px',
      width: '400px',
      borderRadius: '50%',
      overflow: 'hidden'
    })

    gsap.to('.loading__component', {
      delay: 1.5,
      border: 'none',
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    })
    gsap.to('#threejs', {
      delay: 1.5,
      duration: 1,
      opacity: 1
    })
    imagesLoaded(document.querySelectorAll('img'), () => {
      gsap.to('.loading', {
        delay: 2,
        duration: 2,
        //   zIndex: 3,
        background: 'transparent',
        opacity: 0.25,
        position: 'absolute'
      })

      // hero split text
      const tl = gsap.timeline(),
        mySplitText = new SplitText('#hero-split-title', { type: 'words,chars' }),
        chars = mySplitText.chars //an array of all the divs that wrap each character

      gsap.set('#hero-split-title', { perspective: 400 })
      tl.from(chars, {
        duration: 0.8,
        delay: 2,
        opacity: 0,
        scale: 0,
        y: 80,
        rotationX: 180,
        transformOrigin: '0% 50% -50',
        ease: 'back',
        stagger: 0.01
      })
    })
  }
}, 10)
